import React from 'react';
import { SiVisa, SiAmericanexpress, SiJcb } from 'react-icons/si';

export type CardBrand = 'visa' | 'mastercard' | 'amex' | 'jcb';

const NAMES: Record<CardBrand, string> = { visa: 'Visa', mastercard: 'Mastercard', amex: 'American Express', jcb: 'JCB' };

// the card network from the first digits (IIN ranges); undefined until there are enough digits to tell
export const getCardBrand = (number: string): CardBrand | undefined => {
    const d = number.replace(/\D/g, '');
    if (/^4/.test(d)) return 'visa';
    if (/^3[47]/.test(d)) return 'amex';
    if (/^35(2[89]|[3-8])/.test(d)) return 'jcb';
    const four = Number(d.slice(0, 4));
    if (/^5[1-5]/.test(d) || (d.length >= 4 && four >= 2221 && four <= 2720)) return 'mastercard';
    return undefined;
};

// the networks' own marks: Visa wordmark, Mastercard's two circles, Amex and JCB from Simple Icons, in brand colours.
// onDark = on the navy card preview (Visa's wordmark goes white there, as Visa's rules ask)
const CardBrandLogo: React.FC<{ brand: CardBrand; onDark?: boolean; className?: string }> = ({ brand, onDark, className }) => {
    const label = NAMES[brand];
    const cls = `card-brand ${brand}${className ? ` ${className}` : ''}`;
    if (brand === 'mastercard')
        return <svg className={cls} viewBox="0 0 48 30" role="img" aria-label={label}>
            <circle cx="15" cy="15" r="15" fill="#EB001B" />
            <circle cx="33" cy="15" r="15" fill="#F79E1B" />
            <path d="M24 3a15 15 0 0 1 0 24a15 15 0 0 1 0-24z" fill="#FF5F00" />
        </svg>;
    if (brand === 'amex') return <SiAmericanexpress className={cls} color="#2E77BC" aria-label={label} role="img" />;
    if (brand === 'jcb') return <SiJcb className={cls} color={onDark ? '#ffffff' : '#0E4C96'} aria-label={label} role="img" />;
    return <SiVisa className={cls} color={onDark ? '#ffffff' : '#1A1F71'} aria-label={label} role="img" />;
};

export default CardBrandLogo;
